import React from 'react';
import { observer } from 'mobx-react';

import PageComponent from 'js/components/pages/PageComponent';
import { makeRequest } from 'js/services/Network';
import { lightGrey1Color } from 'js/config/style';

import TokenStatusPageState from 'js/stores/pages/TokenStatusPageState';
import TokenStatusPage from './TokenStatusPage';

import ItemStatusPageState from 'js/stores/pages/ItemStatusPageState';
import ItemStatusPage from './ItemStatusPage';

@observer
export default class StatusPage extends PageComponent {
  loginRequired = true;
  pageName = 'StatusPage';
  trackingName = 'BP_checkout_status_offer_pending';
  pageColor = lightGrey1Color;
  backNav = 'preserve';

  bootstrap = () => makeRequest('status-data', this.props).then(({ data }) => this[`${data.mode}Init`](data));
  renderPage = () => {
    return this[`${this.page.mode}Render`]();
  }

  tokenInit = statusData => (this.page = TokenStatusPageState.create(statusData));
  tokenRender = () => <TokenStatusPage />;

  itemInit = statusData => (this.page = ItemStatusPageState.create(statusData));
  itemRender = () => <ItemStatusPage />;

}
